import { useIntl } from 'react-intl';
import { useEventGeneratorClickCta } from 'src/analytics/useEventGeneratorClickCta';
import { Button, SvgHelperWrapper } from 'src/components';
import { useCtaHref } from 'src/hooks/useCtaHref';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import MarketingMessageCard from '../MarketingMessageCard';
import LearnSvg from './images/learn.svg';
import ImmerseSvg from './images/immerse.svg';
import CommunicateSvg from './images/communicate.svg';
import * as S from './styles';
import * as msgsData from './messages';

const { msgs, ...localesWithMessages } = msgsData;

const MarketingMessage = () => {
  const intl = useIntl();
  const targetMsgs = useTargetMessages(localesWithMessages);

  const signUpHref = useCtaHref();
  const eventGeneratorClickCta = useEventGeneratorClickCta();

  return (
    <S.Container>
      <S.Title>{intl.formatMessage(targetMsgs.marketingSectionTitle)}</S.Title>
      <S.SubTitle>{intl.formatMessage(msgs.communicateDescription)}</S.SubTitle>
      <S.BlockItems>
        <MarketingMessageCard
          $type="learn"
          title={intl.formatMessage(msgs.learnTitle)}
          description={intl.formatMessage(msgs.learnMarketingDescription)}
        >
          <SvgHelperWrapper Svg={LearnSvg} />
        </MarketingMessageCard>
        <MarketingMessageCard
          $type="immerse"
          title={intl.formatMessage(msgs.immerseTitle)}
          description={intl.formatMessage(msgs.immerseMarketingDescription)}
        >
          <SvgHelperWrapper Svg={ImmerseSvg} />
        </MarketingMessageCard>
        <MarketingMessageCard
          $type="communicate"
          title={intl.formatMessage(msgs.communicateTitle)}
          description={intl.formatMessage(msgs.communicateMarketingDescription)}
        >
          <SvgHelperWrapper Svg={CommunicateSvg} />
        </MarketingMessageCard>
      </S.BlockItems>
      <S.CTA>
        <Button
          analyticsEvent={eventGeneratorClickCta}
          buttonSizeBreakpoint="md"
          buttonType="primary"
          disableMinWidth
          fullWidth="never"
          href={signUpHref}
        >
          {intl.formatMessage(targetMsgs.ctaButton)}
        </Button>
      </S.CTA>
    </S.Container>
  );
};

export default MarketingMessage;
